<template>
  <div class="step">
    <el-row class="row-box">
      <div class="step-box" >
        <span :class="['item',{active:getPath == '/phoneindex' }]" >
          <router-link  to="/phoneindex">Home</router-link>
        </span>

        <span :class="['item',{active:getPath == '/phoneaboutyedeer'}]" >
          <router-link to="/phoneaboutyedeer">About Yedeer</router-link>
        </span>
        <!-- <span  :class="['item',{active:getPath == 2}]">Recent Jobs</span> -->
      </div>
     
    </el-row>
  </div>
</template>

<script>


export default {
  name: "StepPhone",
  props:{
    
  },
  data() {
    return {
      // isActive:'',
      };
  },
  created(){

    let urls = this.$route
    // // console.log('cndhsjkcnsdkij',urls)
  },
  mounted(){
    // this.isActive = this
  },
  watch:{

  },
  computed:{
    // 获取路由导航
    getPath:{
      get: function () {
        return this.$route.fullPath
      },
    }
  },
  methods:{

  }
};
</script>
<!-- is-finish is-process -->

<style lang="less" scoped>
a{
  text-decoration: none;
  color:rgba(0, 0, 0, 0.75);
}
.step {
  font-family: ArialRoundedmt;

  .row-box{
    position: relative;
  }
  .step-box{
    display: flex;
    .item{
      cursor: pointer;
      margin-right:0.63rem ;
      font-family: arial-unicode-ms;
      color:rgba(0, 0, 0, 0.75);
      font-size: 0.58rem;
      &:last-child{
        margin: 0;
      }
      &.active a{
        color: rgb(0, 0, 0);
        font-weight: 800;
        // font-family: ArialRoundedmt;


      }
    }
  }
}
</style>